export default __webpack_public_path__ + "static/media/09_HueiYoung.691ff409.png";